<template lang="pug">
  DefaultLayout
    ProjectList(archived)
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import ProjectList from '@/components/ProjectList.vue';

export default {
  name: 'ProjectsArchivedPage',
  components: { DefaultLayout, ProjectList },
};
</script>
